import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/articles';

export default function ArticleCards() {
  return (
    <section className="bg-background-50 section-padding">
      <div className="container-custom">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4">
          <div>
            <p className="text-xs font-medium text-secondary-600 uppercase tracking-wider font-label">Latest Resources</p>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mt-2">
              Mulebuy Spreadsheet<br />
              <span className="italic">Guides & Tutorials</span>
            </h2>
            <p className="text-sm text-foreground-500 mt-2 max-w-md">
              {featuredArticles.length} in-depth articles covering everything from beginner setup to advanced automation
            </p>
          </div>
          <span className="inline-flex items-center px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold font-label whitespace-nowrap">
            {featuredArticles.length} ARTICLES
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.seq}
              to={article.slug}
              className="group block rounded-2xl overflow-hidden bg-background-100 hover:bg-background-200/80 transition-all duration-300"
            >
              <div className="relative w-full aspect-[3/4] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <h3 className="text-sm font-semibold text-foreground-800 font-label leading-snug line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-2 leading-relaxed line-clamp-2">
                  {article.subtitle}
                </p>
                <span className="inline-flex items-center gap-1 mt-3 text-xs font-medium text-accent-600 font-label">
                  Read Article <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}